/**
 * Product card layout:
 * [image]
 * [TITLE .............. full width]
 * [price  compare     (+)]
 */
(function () {
  'use strict';

  function isGallery(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.classList.contains('card-gallery')) return true;
    if (el.classList.contains('product-grid-view-zoom-out--details')) return true;
    return false;
  }

  function isActions(el) {
    return el && el.classList && (
      el.classList.contains('drip-pcard__actions') ||
      el.classList.contains('product-card__meta-actions') ||
      el.classList.contains('drip-pcard__meta') ||
      el.classList.contains('drip-pcard__row') ||
      el.classList.contains('drip-pcard__title')
    );
  }

  function isPriceEl(el) {
    if (!el || el.nodeType !== 1) return false;
    if (el.matches('product-price') || el.classList.contains('price')) return true;
    if (el.querySelector('product-price, .price')) return true;
    var t = (el.textContent || '').trim();
    if (/^(Rs\.|₹|\$|€|£)/i.test(t) && t.length < 40) return true;
    return false;
  }

  function layoutCard(card) {
    if (!card || card.dataset.dripLaidOut === '1') return;
    if (card.querySelector(':scope > .drip-pcard__meta')) {
      card.dataset.dripLaidOut = '1';
      return;
    }

    var actions = card.querySelector(':scope > .drip-pcard__actions, :scope > .product-card__meta-actions');
    var kids = Array.prototype.slice.call(card.children);
    var contentKids = kids.filter(function (el) {
      return !isGallery(el) && !isActions(el);
    });

    if (!contentKids.length && !actions) return;

    var titleKids = [];
    var priceKids = [];
    var otherKids = [];

    contentKids.forEach(function (el) {
      if (isPriceEl(el)) priceKids.push(el);
      else titleKids.push(el);
    });

    /* Fallback: first = title, rest = price area */
    if (!titleKids.length && contentKids.length) {
      titleKids = [contentKids[0]];
      priceKids = contentKids.slice(1);
    }

    var meta = document.createElement('div');
    meta.className = 'drip-pcard__meta';

    if (titleKids.length) {
      var titleWrap = document.createElement('div');
      titleWrap.className = 'drip-pcard__title';
      titleKids.forEach(function (el) {
        titleWrap.appendChild(el);
      });
      meta.appendChild(titleWrap);
    }

    var row = document.createElement('div');
    row.className = 'drip-pcard__row';

    var info = document.createElement('div');
    info.className = 'drip-pcard__info';
    priceKids.forEach(function (el) {
      info.appendChild(el);
    });
    otherKids.forEach(function (el) {
      info.appendChild(el);
    });

    row.appendChild(info);
    if (actions) row.appendChild(actions);
    meta.appendChild(row);
    card.appendChild(meta);
    card.dataset.dripLaidOut = '1';
  }

  function scan(root) {
    var cards = (root || document).querySelectorAll('product-card .drip-pcard, product-card .product-card__content');
    for (var i = 0; i < cards.length; i++) layoutCard(cards[i]);
  }

  function start() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });

  document.addEventListener('product-list:updated', function () {
    scan(document);
  });

  function mutationTouchesCards(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (!node || node.nodeType !== 1) continue;
        if (
          node.matches &&
          (node.matches('product-card, product-list, .product-grid, .drip-pcard') ||
            node.querySelector('product-card, .drip-pcard, .product-card__content'))
        ) {
          return true;
        }
      }
    }
    return false;
  }

  if (typeof MutationObserver !== 'undefined') {
    var t = 0;
    var mo = new MutationObserver(function (mutations) {
      if (!mutationTouchesCards(mutations)) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var root = document.querySelector('product-list, .product-grid, #MainContent');
        scan(root || document);
      }, 160);
    });
    var host = document.getElementById('MainContent') || document.body;
    if (host) mo.observe(host, { childList: true, subtree: true });
  }
})();
